import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SetupGuard } from './guards/setup.guard';

import { PaywallComponent } from './paywall/paywall.component';

const routes: Routes = [
  { path: 'paywall', component: PaywallComponent },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [SetupGuard]
  },
  {
    path: 'intro',
    loadChildren: () => import('./intro/intro.module').then( m => m.IntroPageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'contacts-create',
    loadChildren: () => import('./contacts-create/contacts-create.module').then( m => m.ContactsCreatePageModule)
  },
  {
    path: 'contacts-import',
    loadChildren: () => import('./contacts-import/contacts-import.module').then( m => m.ContactsImportPageModule)
  },
  {
    path: 'contacts-import-view',
    loadChildren: () => import('./contacts-import-view/contacts-import-view.module').then( m => m.ContactsImportViewPageModule)
  },
  {
    path: 'contacts-view',
    loadChildren: () => import('./contacts-view/contacts-view.module').then( m => m.ContactsViewPageModule)
  },
  {
    path: 'contacts-edit',
    loadChildren: () => import('./contacts-edit/contacts-edit.module').then( m => m.ContactsEditPageModule)
  },
  {
    path: 'products',
    loadChildren: () => import('./products/products.module').then( m => m.ProductsPageModule)
  },
  {
    path: 'products-view',
    loadChildren: () => import('./products-view/products-view.module').then( m => m.ProductsViewPageModule)
  },
  {
    path: 'products-edit',
    loadChildren: () => import('./products-edit/products-edit.module').then( m => m.ProductsEditPageModule)
  },
  {
    path: 'products-create',
    loadChildren: () => import('./products-create/products-create.module').then( m => m.ProductsCreatePageModule)
  },
  {
    path: 'invoices',
    loadChildren: () => import('./invoices/invoices.module').then( m => m.InvoicesPageModule)
  },
  {
    path: 'invoice-view',
    loadChildren: () => import('./invoice-view/invoice-view.module').then( m => m.InvoiceViewPageModule)
  },
  {
    path: 'invoice-view-pdf',
    loadChildren: () => import('./invoice-view-pdf/invoice-view-pdf.module').then( m => m.InvoiceViewPdfPageModule)
  },
  {
    path: 'invoice-new',
    loadChildren: () => import('./invoice-new/invoice-new.module').then( m => m.InvoiceNewPageModule)
  },
  {
    path: 'appointments-new',
    loadChildren: () => import('./appointments-new/appointments-new.module').then( m => m.AppointmentsNewPageModule)
  },
  {
    path: 'appointments-edit',
    loadChildren: () => import('./appointments-edit/appointments-edit.module').then( m => m.AppointmentsEditPageModule)
  },
  {
    path: 'appointments-view',
    loadChildren: () => import('./appointments-view/appointments-view.module').then( m => m.AppointmentsViewPageModule)
  },
  {
    path: 'jobs-list',
    loadChildren: () => import('./jobs-list/jobs-list.module').then( m => m.JobsListPageModule)
  },
  {
    path: 'quote-new',
    loadChildren: () => import('./quote-new/quote-new.module').then( m => m.QuoteNewPageModule)
  },
  {
    path: 'quotes',
    loadChildren: () => import('./quotes/quotes.module').then( m => m.QuotesPageModule)
  },
  {
    path: 'quote-view',
    loadChildren: () => import('./quote-view/quote-view.module').then( m => m.QuoteViewPageModule)
  },
  {
    path: 'quote-view-pdf',
    loadChildren: () => import('./quote-view-pdf/quote-view-pdf.module').then( m => m.QuoteViewPdfPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'account-wizard',
    loadChildren: () => import('./account-wizard/account-wizard.module').then( m => m.AccountWizardPageModule)
  },
  {
    path: 'user-setup',
    loadChildren: () => import('./user-setup/user-setup.module').then( m => m.UserSetupPageModule)
  },
  {
    path: 'forgotten-password',
    loadChildren: () => import('./forgotten-password/forgotten-password.module').then( m => m.ForgottenPasswordPageModule)
  },
  {
    path: 'business-create',
    loadChildren: () => import('./business-create/business-create.module').then( m => m.BusinessCreatePageModule)
  },
  {
    path: 'invoice-payments-new',
    loadChildren: () => import('./invoice-payments-new/invoice-payments-new.module').then( m => m.InvoicePaymentsNewModule)
  },
  {
    path: 'quote-send',
    loadChildren: () => import('./quote-send/quote-send.module').then( m => m.QuoteSendPageModule)
  },
  {
    path: 'business-edit/:businessId',
    loadChildren: () => import('./business-edit/business-edit.module').then( m => m.BusinessEditPageModule)
  },
  {
    path: 'job-view',
    loadChildren: () => import('./job-view/job-view.module').then( m => m.JobViewPageModule)
  },
  {
    path: 'job-new',
    loadChildren: () => import('./job-new/job-new.module').then( m => m.JobNewPageModule)
  },
  {
    path: 'job-chooser',
    loadChildren: () => import('./job-chooser/job-chooser.module').then( m => m.JobChooserPageModule)
  },
  {
    path: 'job-invoice-list',
    loadChildren: () => import('./job-invoice-list/job-invoice-list.module').then( m => m.JobInvoiceListPageModule)
  },
  {
    path: 'property-edit',
    loadChildren: () => import('./property-edit/property-edit.module').then( m => m.PropertyEditPageModule)
  },
  {
    path: 'property-view',
    loadChildren: () => import('./property-view/property-view.module').then( m => m.PropertyViewPageModule)
  },
  {
    path: 'business-edit-contact',
    loadChildren: () => import('./business-edit-contact/business-edit-contact.module').then( m => m.BusinessEditContactPageModule)
  },
  {
    path: 'business-edit-payment',
    loadChildren: () => import('./business-edit-payment/business-edit-payment.module').then( m => m.BusinessEditPaymentPageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'business-edit-quotesettings',
    loadChildren: () => import('./business-edit-quotesettings/business-edit-quotesettings.module').then( m => m.BusinessEditQuotesettingsPageModule)
  },
  {
    path: 'business-edit-invoicesettings',
    loadChildren: () => import('./business-edit-invoicesettings/business-edit-invoicesettings.module').then( m => m.BusinessEditInvoicesettingsPageModule)
  },
  {
    path: 'business-edit-payment-add',
    loadChildren: () => import('./business-edit-payment-add/business-edit-payment-add.module').then( m => m.BusinessEditPaymentAddPageModule)
  },
  {
    path: 'business-edit-payment-edit',
    loadChildren: () => import('./business-edit-payment-edit/business-edit-payment-edit.module').then( m => m.BusinessEditPaymentEditPageModule)
  },
  {
    path: 'location-search',
    loadChildren: () => import('./location-search/location-search.module').then( m => m.LocationSearchPageModule)
  },
  {
    path: 'business-edit-tax',
    loadChildren: () => import('./business-edit-tax/business-edit-tax.module').then( m => m.BusinessEditTaxPageModule)
  },
  {
    path: 'schedule',
    loadChildren: () => import('./schedule/schedule.module').then( m => m.SchedulePageModule)
  },
  {
    path: 'subscription',
    loadChildren: () => import('./subscription/subscription.module').then( m => m.SubscriptionPageModule)
  },
  {
    path: 'subscription-browse',
    loadChildren: () => import('./subscription-browse/subscription-browse.module').then( m => m.SubscriptionBrowsePageModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then( m => m.ReportsPageModule)
  },
  {
    path: 'reports-invoices-monthly',
    loadChildren: () => import('./reports-invoices-monthly/reports-invoices-monthly.module').then( m => m.ReportsInvoicesMonthlyPageModule)
  },
  {
    path: 'reports-invoices-monthly-view',
    loadChildren: () => import('./reports-invoices-monthly-view/reports-invoices-monthly-view.module').then( m => m.ReportsInvoicesMonthlyViewPageModule)
  },
  {
    path: 'galleries',
    loadChildren: () => import('./gallery/gallery.module').then( m => m.GalleryPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
